import { CartLoadingModalSkeleton } from "../../../components/skeletons/AppPageSkeletons";

interface LoadingProps {
  isOpen: boolean;
}

export default function LoadingCart(props: LoadingProps) {
  return <CartLoadingModalSkeleton open={props.isOpen} />;
}
